const STORAGE_PREFIX = 'scoring-pending-mutation:';
export const PENDING_MUTATION_TTL_MS = 24 * 60 * 60 * 1000;
export const isPendingMutationExpired = (mutation, now = Date.now()) => (
  Number.isFinite(Number(mutation?.createdAt)) && now - Number(mutation.createdAt) > PENDING_MUTATION_TTL_MS
);

const keyFor = (matchId) => `${STORAGE_PREFIX}${String(matchId || '')}`;

const storageAvailable = () => typeof window !== 'undefined' && window.localStorage;

const isValid = (value) => Boolean(
  value &&
  typeof value === 'object' &&
  typeof value.requestId === 'string' &&
  value.requestId &&
  typeof value.matchId === 'string' &&
  value.matchId &&
  value.payload &&
  typeof value.payload === 'object'
);

export const savePendingScoringMutation = (mutation) => {
  if (!storageAvailable() || !isValid(mutation)) return false;
  window.localStorage.setItem(keyFor(mutation.matchId), JSON.stringify(mutation));
  return true;
};

export const loadPendingScoringMutation = (matchId) => {
  if (!storageAvailable()) return null;
  const raw = window.localStorage.getItem(keyFor(matchId));
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!isValid(parsed)) {
      window.localStorage.removeItem(keyFor(matchId));
      return null;
    }
    return parsed;
  } catch {
    window.localStorage.removeItem(keyFor(matchId));
    return null;
  }
};

export const removePendingScoringMutation = (matchId) => {
  if (storageAvailable()) window.localStorage.removeItem(keyFor(matchId));
};

export const listPendingScoringMutations = () => {
  if (!storageAvailable()) return [];
  const result = [];
  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (!key?.startsWith(STORAGE_PREFIX)) continue;
    const parsed = loadPendingScoringMutation(key.slice(STORAGE_PREFIX.length));
    if (parsed) result.push(parsed);
  }
  return result;
};
